import { emitToCustomErrorDisplay } from '../custom/utils/emitError'

const supportedFileTypes: string[] = ['image/png', 'image/jpg', 'image/jpeg']

const mediaSizeLimits = {
  maxFileCount: 1,
  maxFileSize: 1048576,
}

interface Props {
  inputName: string
  onPreview: (imageUrl: string) => void
  inputRef: React.RefObject<HTMLInputElement>
}

const MediaStagingArea: React.FC<Props> = ({
  inputName,
  onPreview,
  inputRef,
}) => {
  const resetInput = () => {
    if (inputRef.current) inputRef.current.value = ''
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target

    if (!input.files || input.files.length === 0) {
      return emitToCustomErrorDisplay('Please select a valid image file.')
    }

    if (input.files.length > mediaSizeLimits.maxFileCount) {
      resetInput()
      return emitToCustomErrorDisplay('Max upload file count is 1.')
    }

    const file = input.files[0]
    const limit = supportedFileTypes.includes(file.type)

    if (!limit) {
      resetInput()
      return emitToCustomErrorDisplay('Valid file types are: .png, .jpg, .jpeg')
    }

    if (file.size > mediaSizeLimits.maxFileSize) {
      resetInput()
      return emitToCustomErrorDisplay(`File too large: 1MB max.`)
    }

    const reader = new FileReader()
    reader.onload = (e) => {
      const arrayBuffer = e.target?.result
      if (!arrayBuffer) {
        return emitToCustomErrorDisplay('Unable to read file.')
      }
      const blob = new Blob([arrayBuffer], { type: file.type })
      const url = URL.createObjectURL(blob)
      onPreview(url)
    }
    reader.readAsArrayBuffer(file)
  }

  return (
    <input
      ref={inputRef}
      name={inputName}
      type="file"
      accept="image/png, image/jpg, image/jpeg"
      style={{ display: 'none' }}
      onChange={handleChange}
    />
  )
}

export default MediaStagingArea
